{
  "AGENT_BOTS": {
    "HEADER": "Bots",
    "LOADING_EDITOR": "A carregar editor...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try.You can manage your bots from this page or create new ones using the 'Configure new bot' button.",
    "LEARN_MORE": "Learn about agent bots",
    "GLOBAL_BOT_BADGE": "Sistema",
    "AVATAR": {
      "SUCCESS_DELETE": "Avatar do bot excluído com sucesso",
      "ERROR_DELETE": "Erro ao excluir o avatar do bot, tente novamente"
    },
    "CSML_BOT_EDITOR": {
      "NAME": {
        "LABEL": "Nome do bot",
        "PLACEHOLDER": "Dê um nome ao seu bot.",
        "ERROR": "O nome do bot é obrigatório."
      },
      "DESCRIPTION": {
        "LABEL": "Descrição do bot",
        "PLACEHOLDER": "O que faz este bot?"
      },
      "BOT_CONFIG": {
        "ERROR": "Por favor, insira, acima, a sua configuração CSML do bot.",
        "API_ERROR": "A sua configuração CSML é inválida. Por favor, corrija-a e tente novamente."
      },
      "SUBMIT": "Validar e guardar"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Selecione um agente bot",
      "DESC": "Atribua um agente bot à sua caixa de entrada. Eles podem lidar com conversas iniciais e transferi-las para um agente humano quando necessário.",
      "OPTION": "{name} ({description})",
      "SUBMIT": "Atualização",
      "DISCONNECT": "Desligar bot",
      "SUCCESS_MESSAGE": "Agente bot atualizado com sucesso.",
      "DISCONNECTED_SUCCESS_MESSAGE": "O agente bot foi desligado com sucesso.",
      "ERROR_MESSAGE": "Não foi possível atualizar o agente bot. Por favor, tente novamente.",
      "DISCONNECTED_ERROR_MESSAGE": "Não foi possível desligar o agente bot. Por favor, tente novamente.",
      "SELECT_PLACEHOLDER": "Selecionar bot",
      "COUNTRY_BOTS": {
        "TITLE": "Bots por país",
        "DESC": "Esta caixa de entrada atende vários países. Uma conversa vai para o bot do seu país: de acordo com a loja Kaufland, o marketplace do pedido Allegro ou, caso contrário, o idioma em que o cliente escreve. As restantes conversas vão para o bot predefinido acima.",
        "COUNTRY": "Selecione um país",
        "BOT": "Selecionar bot",
        "ADD": "Adicionar bot para um país",
        "REMOVE": "Remover",
        "DEFAULT_REQUIRED": "Selecione primeiro um bot predefinido. O bot de um país substitui-o apenas para esse país.",
        "DISCONNECT_ALL": "Desligar todos os bots"
      }
    },
    "ADD": {
      "TITLE": "Configurar novo bot",
      "CANCEL_BUTTON_TEXT": "Cancelar",
      "API": {
        "SUCCESS_MESSAGE": "Bot adicionado com sucesso.",
        "ERROR_MESSAGE": "Não foi possível adicionar o bot. Por favor, tente novamente mais tarde."
      }
    },
    "LIST": {
      "404": "Nenhum bot encontrado. Pode criar um bot clicando no botão 'Configurar novo bot' ↗️",
      "LOADING": "A carregar bots...",
      "TABLE_HEADER": {
        "DETAILS": "Detalhes do bot",
        "URL": "URL do webhook"
      },
      "TYPE": "Tipo de bot"
    },
    "DELETE": {
      "BUTTON_TEXT": "Excluir",
      "TITLE": "Apagar bot",
      "CONFIRM": {
        "TITLE": "Confirmar exclusão",
        "MESSAGE": "Tem a certeza que pretende excluir {name}?",
        "YES": "Sim, excluir",
        "NO": "Não, manter"
      },
      "SUBMIT": "Excluir",
      "CANCEL_BUTTON_TEXT": "Cancelar",
      "DESCRIPTION": "Tem a certeza que pretende excluir este bot? Esta ação é irreversível.",
      "API": {
        "SUCCESS_MESSAGE": "Bot apagado com sucesso.",
        "ERROR_MESSAGE": "Não foi possível apagar o bot. Por favor, tente novamente."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Editar",
      "LOADING": "A carregar bots...",
      "TITLE": "Editar bot",
      "CANCEL_BUTTON_TEXT": "Cancelar",
      "API": {
        "SUCCESS_MESSAGE": "Bot atualizado com sucesso.",
        "ERROR_MESSAGE": "Não foi possível atualizar o bot. Por favor, tente novamente."
      }
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Avatar do bot"
      },
      "NAME": {
        "LABEL": "Nome do bot",
        "PLACEHOLDER": "Introduza o nome do bot"
      },
      "DESCRIPTION": {
        "LABEL": "Descrição",
        "PLACEHOLDER": "O que faz este bot?"
      },
      "WEBHOOK_URL": {
        "LABEL": "URL do webhook",
        "PLACEHOLDER": "https://example.com/webhook"
      },
      "ERRORS": {
        "NAME": "O nome do bot é obrigatório",
        "URL": "O URL do webhook é obrigatório",
        "VALID_URL": "Introduza um URL válido, começado por http:// ou https://"
      },
      "CANCEL": "Cancelar",
      "CREATE": "Criar bot",
      "UPDATE": "Atualizar bot"
    },
    "TYPES": {
      "WEBHOOK": "Webhook bot",
      "CSML": "CSML bot"
    }
  }
}
